// src/app/routes/notFoundRoutes.jsx
import React, { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const NotFoundPage = lazy(() => import("../../pages/NotFoundPage"));

export function renderNotFoundRoutes() {
  return (
    <>
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </>
  );
}
